import React from 'react';
import Header from './header';
import ListaProcessos from './ListaProcessos';
import { connect } from 'react-redux';
import { logout, mudarUser, mudarLoadingHome, mudarFaculdade } from '../actions/AppActions';
import { URL } from '../variables';
import { Route, Switch, Redirect, Link } from "react-router-dom";
import Sala from './Sala';
import Interview from './Interview';
import { languages, getSelectedLanguage } from '../languages';
import Loader from '../components/Loader';

const OtherRoute = ({ component: Component, path_name, ...rest }) => (<Route {...rest} render={props => <Redirect to={{ pathname: path_name, state: { from: props.location } }} />} />);

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = { selectedLanguage: getSelectedLanguage() };
    this.videoRef = React.createRef();
    this.imageRef = React.createRef();
  }
  logout() { localStorage.removeItem('token'); this.props.logout(); }

  componentDidMount() {
    this.props.mudarLoadingHome(true);
    this.languageListener = () => this.setState({ selectedLanguage: getSelectedLanguage() });
    window.addEventListener('avaliador_language_change', this.languageListener);
    this.get_user();
  }

  componentWillUnmount() { if (this.languageListener) window.removeEventListener('avaliador_language_change', this.languageListener); }

  async get_user() {
    fetch(`${URL}api/avaliador/get_user/`, { method: 'GET', headers: { Accept: 'application/json', 'Authorization': `Bearer ${this.props.token}` } }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        if (resp.message == "Unauthenticated.") { localStorage.removeItem('token'); this.props.logout(); }
        if (resp.errors != null || resp.error != null) setTimeout(() => { this.get_user(); }, 5000);
        else { this.props.mudarUser(resp.user); this.props.mudarFaculdade(resp.faculdade); this.props.mudarLoadingHome(false); }
      } catch (err) { console.log(err); setTimeout(() => { this.get_user(); }, 5000); }
    }).catch((err) => { console.log(err); setTimeout(() => { this.get_user(); }, 5000); });
  }

  componentDidUpdate() { if (this.props.stream != null && this.videoRef.current != null) this.videoRef.current.srcObject = this.props.stream; }
  getTexts() { return languages[this.state.selectedLanguage] || languages.Pt; }

  getBreadcrumbItems() {
    let t = this.getTexts();
    let baseUrl = this.props.match.url;
    let pathname = this.props.location.pathname;
    let path = pathname.replace(baseUrl, '').replace(/^\/+/, '');
    let section = path.split('/')[0];
    let homeUrl = baseUrl || '/';
    let items = [{ label: t.breadcrumb_home, to: homeUrl }, { label: this.props.faculdade.name, to: homeUrl }];
    if (section === '') items.push({ label: t.breadcrumb_processes });
    else if (section === 'sala') { items.push({ label: t.breadcrumb_processes, to: homeUrl }); items.push({ label: t.breadcrumb_room }); }
    else if (section === 'presentation') { items.push({ label: t.breadcrumb_processes, to: homeUrl }); items.push({ label: t.breadcrumb_interview }); }
    return items;
  }

  renderBreadcrumb() {
    let items = this.getBreadcrumbItems();
    return <nav className="avaliador-breadcrumb" aria-label="breadcrumb">{items.map((item, index) => <React.Fragment key={index}>{item.to && index < items.length - 1 ? <Link to={item.to}>{item.label}</Link> : (index === items.length - 1 ? <strong>{item.label}</strong> : <span>{item.label}</span>)}{index < items.length - 1 && <i className="mdi mdi-chevron-right"></i>}</React.Fragment>)}</nav>;
  }

  render() {
    let t = this.getTexts();
    return (
      <div className="avaliador-app-shell">
        <img ref={this.imageRef} src="/imgs/eu.jpeg" hidden alt="" />
        <div id="wrapper">
          {this.props.show_call == false && <Header />}
          {this.props.loading_home == false && <div className="avaliador-system-shell">
            <div className="content-page avaliador-content-page" style={{ marginLeft: 0 }}><div className="content"><div className="container-fluid avaliador-container" style={{ padding: this.props.sala_screen == true ? 0 : '' }}>
              {this.props.sala_screen == false && <div className="page-title-box avaliador-page-title-box"><div className="row align-items-center"><div className="col-sm-12"><span>{t.evaluator_area}</span><h2>{this.props.faculdade.name}</h2>{this.renderBreadcrumb()}</div></div></div>}
              <Switch>
                <Route exact path={`${this.props.match.url}`} render={(props2) => <ListaProcessos {...props2} t={t} />} />
                <Route exact path={`${this.props.match.url}sala/:id`} render={(props2) => <Sala {...props2} t={t} />} />
                <Route exact path={`${this.props.match.url}presentation/:id`} render={(props2) => <Interview {...props2} t={t} />} />
                <OtherRoute path="*" path_name='/' />
              </Switch>
            </div></div></div>
          </div>}
          {this.props.loading_home == true && <Loader fullScreen title={t.loading_data} description={t.loading_environment} />}
        </div>
      </div>
    );
  }
}

const mapsStateToProps = (state) => ({ faculdade: state.AppReducer.faculdade, token: state.AppReducer.token, loading_home: state.AppReducer.loading_home, stream: state.AppReducer.stream, processo: state.AppReducer.processo, sala_screen: state.AppReducer.sala_screen, show_call: state.AppReducer.show_call });
export default connect(mapsStateToProps, { logout, mudarUser, mudarLoadingHome, mudarFaculdade })(Home);
